var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '마이페이지'
    }
  }), _c('mypage-navigation'), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "Operation status",
      "tit": "가동현황"
    }
  }), _c('mes-dashboard-calendar', _vm._g(_vm._b({
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  }, 'mes-dashboard-calendar', {
    type: _vm.type,
    events: _vm.events,
    categories: _vm.categories
  }, false), {
    typeChange: _vm.typeChange
  })), _c('div', {
    staticClass: "mt-14 mt-lg-20"
  }, [_c('v-row', {
    staticClass: "mx-lg-n14"
  }, [_c('v-spacer', {
    staticClass: "d-none d-sm-block"
  }), _vm._l(_vm.categoriesWithColor, function (item) {
    return _c('v-col', {
      key: item.category,
      staticClass: "d-flex align-center pa-lg-14",
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', {
      staticClass: "color d-block mr-8 mr-lg-16",
      style: 'background-color: ' + item.color
    }), _c('span', {
      staticClass: "page-text--sm color-grey"
    }, [_vm._v(_vm._s(item.category))])]);
  })], 2)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }